import React, { FC, useState } from 'react';
import { View } from 'react-native';

import Link from '../LinkBase';

export type IconButtonBaseProps = {
  children: any;
  containerStyle?: any;
  disabled?: boolean;
  disabledContainerStyle?: any;
  hoverStyle?: any;
  onPress: (e: any) => void;
  style?: any;
};

//    TODO: ADD disabled and loading props
const IconButtonBase: FC<IconButtonBaseProps> = (props) => {
  const {
    children,
    containerStyle,
    disabled,
    disabledContainerStyle,
    hoverStyle,
    onPress,
    style,
  } = props;
  const [isHovering, setHoverState] = useState(false);
  const onHover = (isHovering) => {
    setHoverState(isHovering);
  };

  const getStyle = () => {
    if (isHovering && !disabled) {
      return hoverStyle;
    } else if (disabled) {
      return disabledContainerStyle;
    }
    return containerStyle;
  };

  return (
    <Link
      accessibilityRole="button"
      disabled={disabled}
      onHover={onHover}
      onPress={onPress}
    >
      <View style={getStyle()}>{children}</View>
    </Link>
  );
};

export default IconButtonBase;
